import { render, staticRenderFns } from "./RecentlyViewedProducts.vue?vue&type=template&id=1e5c3e84&scoped=true&"
import script from "./RecentlyViewedProducts.vue?vue&type=script&lang=js&"
export * from "./RecentlyViewedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5c3e84",
  null
  
)

component.options.__file = "RecentlyViewedProducts.vue"
export default component.exports